import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

@Component({
    imports: [],
    selector: 'app-data-redirector',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MedpaceDataRedirectorComponent {
    constructor(router: Router, route: ActivatedRoute) {
        const data = route.snapshot?.data;
        const extras: NavigationExtras = {
            queryParams: { params: JSON.stringify(data?.content) },
        };
        router.navigate([data?.redirectTo], extras);
    }
}
